<mat-form-field appearance="outline" [formGroup]="form">
  <mat-label>{{label}}</mat-label>
  <input [formControlName]="controlName" matInput [placeholder]="placeholder" [value]="initialValue || ''" [errorStateMatcher]="matcher"/>
  <mat-error *ngFor="let validation of validationMessages">
    <mat-error class="error-message" *ngIf="form.get(controlName).hasError(validation.type)">
      {{validation.message}}
    </mat-error>
  </mat-error>
</mat-form-field>
